module["exports"] = [
  "np",
  "com",
  "info",
  "net",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/internet/domain_suffix.js
// module id = 1886
// module chunks = 0